export const ContactManagementTabs = {
  DETAILS: 'details',
  WINECLUB: 'subscriptions',
  ORDERS: 'orders',
  EVENTS: 'events',
};
